import { call, getContext } from 'redux-saga/effects';
import { SagaContext } from 'shared/types/common';
import { Services } from 'init/services';
import { mainAccountQuery } from 'shared/queries/MainAccountsQuery/builder';
import { MainAccountsQuery } from 'shared/queries/MainAccountsQuery/__generated__/MainAccountsQuery';

export function* getBalance(currency: string) {
  const apolloClient: Services[SagaContext.ApolloClient] = yield getContext(
    SagaContext.ApolloClient
  );

  const { data }: { data: MainAccountsQuery } = yield call(apolloClient.query, mainAccountQuery());
  const result = data.billing.mainAccounts.find(({ balance }) => balance.currency === currency);

  return result ? result.balance.value : 0;
}
